import React from 'react';

const Hero = ({children, size, image, centeredText, hiddenMobile}) => {
    let backgroundImage;

    if(image){
        backgroundImage = {
            backgroundImage: `url(${image})`
        }
    }

    return (
        <section className={`hero custom-hero ${centeredText ? 'has-text-centered' : ''} ${hiddenMobile ? 'is-hidden-mobile' : ''} ${size}`} style={backgroundImage}>
            <div className="hero-body">
                <div className="container">
                    { children }
                </div>
            </div>
        </section>
    );
}

export default Hero;


// WEBPACK FOOTER //
// ./src/components/hero/index.js